import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rfqs: [],
  isLoading: false,
  isError: false,
  message: '',
};

export const rfqSlice = createSlice({
  name: 'rfqs',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.message = '';
    },
  },
});

export const { reset } = rfqSlice.actions;
export default rfqSlice.reducer;